import { SiteHeader } from "@/components/site-header"
import { Link } from "react-router-dom"
import { ArrowLeftIcon } from "lucide-react"

export default function CargoDocumentsRulesPage() {
  return (
    <>
      <SiteHeader title="Reglas de exportación — Documentos de Carga" />
      <div className="flex flex-1 flex-col px-4 py-6 lg:px-6">
        <div className="max-w-4xl space-y-8">

          {/* Breadcrumb */}
          <div>
            <Link
              to="/docs"
              className="inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground mb-4"
            >
              <ArrowLeftIcon className="size-3" /> Documentación
            </Link>
            <h2 className="text-base font-semibold mb-1">Reglas de exportación — Documentos de Carga</h2>
            <p className="text-sm text-muted-foreground">
              Descripción completa de cómo se genera el archivo <code className="font-mono text-xs">documentos-de-carga.csv</code>.
              Endpoint: <code className="font-mono text-xs">POST /api/smart-gt/export/cargo-documents</code>.
            </p>
          </div>

          {/* ─── Estructura general ─── */}
          <section className="space-y-3">
            <h3 className="text-sm font-semibold">Estructura general</h3>
            <p className="text-xs text-muted-foreground">
              Cada CRT genera <span className="font-medium text-foreground">hasta 2 filas</span> en el archivo:
              una fila <code className="font-mono">CR</code> (documento de transporte) y una fila{" "}
              <code className="font-mono">FC</code> (factura comercial). Ambas comparten el mismo{" "}
              <code className="font-mono">ID EXTERNO</code> y <code className="font-mono">FECHA</code>.
            </p>
            <div className="rounded-lg border overflow-hidden text-sm">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="bg-muted/50 border-b">
                    <th className="text-left px-4 py-2 text-xs font-medium w-8">#</th>
                    <th className="text-left px-4 py-2 text-xs font-medium">Columna</th>
                    <th className="text-left px-4 py-2 text-xs font-medium">Fila CR</th>
                    <th className="text-left px-4 py-2 text-xs font-medium">Fila FC (AR)</th>
                    <th className="text-left px-4 py-2 text-xs font-medium">Fila FC (BR/otros)</th>
                  </tr>
                </thead>
                <tbody className="divide-y text-xs">
                  <tr>
                    <td className="px-4 py-2.5 text-muted-foreground">1</td>
                    <td className="px-4 py-2.5 font-medium">ID EXTERNO</td>
                    <td className="px-4 py-2.5"><code className="font-mono">"GT" + source_id</code></td>
                    <td className="px-4 py-2.5"><code className="font-mono">"GT" + source_id</code></td>
                    <td className="px-4 py-2.5"><code className="font-mono">"GT" + source_id</code></td>
                  </tr>
                  <tr className="bg-muted/20">
                    <td className="px-4 py-2.5 text-muted-foreground">2</td>
                    <td className="px-4 py-2.5 font-medium">FILIAL</td>
                    <td className="px-4 py-2.5"><span className="font-mono bg-muted px-1.5 py-0.5 rounded">1</span></td>
                    <td className="px-4 py-2.5"><span className="font-mono bg-muted px-1.5 py-0.5 rounded">1</span></td>
                    <td className="px-4 py-2.5"><span className="font-mono bg-muted px-1.5 py-0.5 rounded">1</span></td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5 text-muted-foreground">3</td>
                    <td className="px-4 py-2.5 font-medium">FECHA</td>
                    <td className="px-4 py-2.5"><code className="font-mono">collection_arrival</code></td>
                    <td className="px-4 py-2.5"><code className="font-mono">collection_arrival</code></td>
                    <td className="px-4 py-2.5"><code className="font-mono">collection_arrival</code></td>
                  </tr>
                  <tr className="bg-muted/20">
                    <td className="px-4 py-2.5 text-muted-foreground">4</td>
                    <td className="px-4 py-2.5 font-medium">TIPO</td>
                    <td className="px-4 py-2.5"><span className="font-mono bg-muted px-1.5 py-0.5 rounded">CR</span></td>
                    <td className="px-4 py-2.5"><span className="font-mono bg-muted px-1.5 py-0.5 rounded">FC</span></td>
                    <td className="px-4 py-2.5"><span className="font-mono bg-muted px-1.5 py-0.5 rounded">FC</span></td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5 text-muted-foreground">5</td>
                    <td className="px-4 py-2.5 font-medium">LETRA</td>
                    <td className="px-4 py-2.5"><span className="font-mono bg-muted px-1.5 py-0.5 rounded">T</span></td>
                    <td className="px-4 py-2.5"><span className="font-mono bg-muted px-1.5 py-0.5 rounded">E</span></td>
                    <td className="px-4 py-2.5 text-muted-foreground">(vacío)</td>
                  </tr>
                  <tr className="bg-muted/20">
                    <td className="px-4 py-2.5 text-muted-foreground">6</td>
                    <td className="px-4 py-2.5 font-medium">CEN. EMISOR</td>
                    <td className="px-4 py-2.5 text-muted-foreground">2 letras + 1er dígito del CRT</td>
                    <td className="px-4 py-2.5 text-muted-foreground">Parte izquierda del invoice (ver parseo)</td>
                    <td className="px-4 py-2.5 text-muted-foreground">(vacío)</td>
                  </tr>
                  <tr>
                    <td className="px-4 py-2.5 text-muted-foreground">7</td>
                    <td className="px-4 py-2.5 font-medium">NUMERO</td>
                    <td className="px-4 py-2.5 text-muted-foreground">Dígitos restantes del CRT</td>
                    <td className="px-4 py-2.5 text-muted-foreground">Dígitos sin ceros líderes (ver parseo)</td>
                    <td className="px-4 py-2.5 text-muted-foreground">Invoice completo tal cual</td>
                  </tr>
                  <tr className="bg-muted/20">
                    <td className="px-4 py-2.5 text-muted-foreground">8</td>
                    <td className="px-4 py-2.5 font-medium">DESCRIPCION</td>
                    <td className="px-4 py-2.5"><code className="font-mono">FC.: {"{invoice}"}</code></td>
                    <td className="px-4 py-2.5 text-muted-foreground">(vacío)</td>
                    <td className="px-4 py-2.5 text-muted-foreground">(vacío)</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-xs text-muted-foreground">
              <span className="font-medium text-foreground">Fuente del detalle</span>: se hace LEFT JOIN con{" "}
              <code className="font-mono">smart_gt_crt_details</code> ordenado por{" "}
              <code className="font-mono">source_id ASC</code>. Solo se usa el primer detalle por CRT
              (el de menor <code className="font-mono">source_id</code>) para obtener{" "}
              <code className="font-mono">collection_arrival</code> e <code className="font-mono">ID EXTERNO</code>.
            </p>
          </section>

          {/* ─── Exclusiones globales ─── */}
          <section className="space-y-3">
            <h3 className="text-sm font-semibold">Exclusiones — orden de evaluación</h3>
            <p className="text-xs text-muted-foreground">
              Las siguientes condiciones se evalúan <span className="font-medium text-foreground">en orden</span> antes de generar cualquier fila.
              Un CRT que cumpla cualquiera de ellas no genera ni la fila CR ni la fila FC.
            </p>

            {/* Exclusión 1 — Confirmado */}
            <div className="rounded-lg border bg-muted/20 px-4 py-3 space-y-1.5">
              <div className="flex items-center gap-2">
                <span className="text-xs font-mono text-muted-foreground w-4">1.</span>
                <p className="text-xs font-semibold">CRT con estado Confirmado</p>
                <span className="ml-auto text-xs text-red-600 dark:text-red-400 font-medium">✗ excluido completo</span>
              </div>
              <p className="text-xs text-muted-foreground pl-6">
                Filtrado directamente en la query SQL con{" "}
                <code className="font-mono">crt_status != 'Confirmado'</code>.
                No genera ninguna fila — el CRT ya fue procesado anteriormente.
              </p>
            </div>

            {/* Exclusión 2 — Manual */}
            <div className="rounded-lg border bg-muted/20 px-4 py-3 space-y-1.5">
              <div className="flex items-center gap-2">
                <span className="text-xs font-mono text-muted-foreground w-4">2.</span>
                <p className="text-xs font-semibold">CRT manual</p>
                <span className="ml-auto text-xs text-red-600 dark:text-red-400 font-medium">✗ excluido completo</span>
              </div>
              <p className="text-xs text-muted-foreground pl-6">
                Filtrado con <code className="font-mono">is_manual = false</code>.
                Los CRTs creados manualmente (conexión entre destinos o formulario "Nuevo CRT")
                no generan documentos de carga.
              </p>
            </div>

            {/* Exclusión 3 — Regla 3b TJ */}
            <div className="rounded-lg border bg-red-50/50 dark:bg-red-950/20 border-red-200 dark:border-red-800 px-4 py-3 space-y-1.5">
              <div className="flex items-center gap-2">
                <span className="text-xs font-mono text-muted-foreground w-4">3.</span>
                <p className="text-xs font-semibold">
                  <span className="text-red-700 dark:text-red-400">Regla 3b TJ</span>
                  {" "}— Carrier TransJovem + propietario fletero externo
                </p>
                <span className="ml-auto text-xs text-red-600 dark:text-red-400 font-medium">✗ excluido completo</span>
              </div>
              <p className="text-xs text-muted-foreground pl-6">
                Si el <code className="font-mono">carrier</code> contiene "TRANSJOV" y el{" "}
                <code className="font-mono">truck_owner</code> no es CDC, Kaizen ni TransJovem
                (es un fletero externo), el CRT se excluye de todos los exports incluyendo documentos.
              </p>
            </div>

            {/* Exclusión 4 — Regla 3a bis */}
            <div className="rounded-lg border bg-orange-50/50 dark:bg-orange-950/20 border-orange-200 dark:border-orange-800 px-4 py-3 space-y-1.5">
              <div className="flex items-center gap-2">
                <span className="text-xs font-mono text-muted-foreground w-4">4.</span>
                <p className="text-xs font-semibold">
                  <span className="text-orange-700 dark:text-orange-400">Regla 3a(bis)</span>
                  {" "}— Carrier TransJovem + propietario TJ (camión propio)
                </p>
                <span className="ml-auto text-xs text-red-600 dark:text-red-400 font-medium">✗ excluido completo</span>
              </div>
              <p className="text-xs text-muted-foreground pl-6">
                Si tanto el <code className="font-mono">carrier</code> como el{" "}
                <code className="font-mono">truck_owner</code> son TransJovem, no se generan documentos
                de carga ni datos de carga. El viaje y la valorización sí se procesan normalmente.
                Controlada por el flag <code className="font-mono">replaceTJClient</code>.
              </p>
            </div>

            {/* Exclusión 5 — Carrier desconocido */}
            <div className="rounded-lg border bg-muted/20 px-4 py-3 space-y-1.5">
              <div className="flex items-center gap-2">
                <span className="text-xs font-mono text-muted-foreground w-4">5.</span>
                <p className="text-xs font-semibold">Carrier que no es CDC ni TransJovem</p>
                <span className="ml-auto text-xs text-red-600 dark:text-red-400 font-medium">✗ excluido completo</span>
              </div>
              <p className="text-xs text-muted-foreground pl-6">
                Si el <code className="font-mono">carrier</code> no contiene "CDC" ni "TRANSJOV",
                el CRT se considera de transportadora desconocida y se excluye de todos los exports.
              </p>
            </div>
          </section>

          {/* ─── Regla invoice A INFORMAR ─── */}
          <section className="space-y-3">
            <h3 className="text-sm font-semibold">Regla — Invoice "A INFORMAR"</h3>
            <div className="rounded-lg border bg-amber-50/50 dark:bg-amber-950/20 border-amber-200 dark:border-amber-800 px-4 py-4 space-y-3">
              <p className="text-xs text-muted-foreground">
                Cuando el valor del campo <code className="font-mono">commercial_invoice</code> es{" "}
                <code className="font-mono">"A INFORMAR"</code>, <code className="font-mono">"A informar"</code> o{" "}
                cualquier variante (normalizado: sin espacios, en mayúsculas = <code className="font-mono">"AINFORMAR"</code>):
              </p>
              <div className="rounded border overflow-hidden">
                <table className="w-full text-xs border-collapse">
                  <thead>
                    <tr className="bg-muted/50 border-b">
                      <th className="text-left px-3 py-2 font-medium">Fila</th>
                      <th className="text-left px-3 py-2 font-medium">Resultado</th>
                      <th className="text-left px-3 py-2 font-medium">Detalle</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    <tr>
                      <td className="px-3 py-2 font-mono font-medium">CR</td>
                      <td className="px-3 py-2 text-green-700 dark:text-green-400 font-medium">✓ se emite</td>
                      <td className="px-3 py-2 text-muted-foreground">
                        Se genera normalmente. DESCRIPCION muestra{" "}
                        <code className="font-mono">FC.: A INFORMAR</code>.
                      </td>
                    </tr>
                    <tr className="bg-muted/10">
                      <td className="px-3 py-2 font-mono font-medium">FC</td>
                      <td className="px-3 py-2 text-red-600 dark:text-red-400 font-medium">✗ omitida</td>
                      <td className="px-3 py-2 text-muted-foreground">
                        No se genera. El chequeo se hace sobre el <span className="font-medium text-foreground">string crudo</span>{" "}
                        antes de pasar por el parseo, para evitar que el slice de 4 caracteres
                        produzca <code className="font-mono">CEN. EMISOR="A IN"</code> y{" "}
                        <code className="font-mono">NUMERO="FORMAR"</code>.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="rounded border bg-muted/30 px-3 py-2 space-y-1">
                <p className="text-[11px] font-medium text-muted-foreground uppercase tracking-wide">Ejemplo real</p>
                <div className="grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5 text-xs">
                  <span className="font-mono text-muted-foreground">AR91062</span>
                  <span className="text-muted-foreground">
                    commercial_invoice = "A INFORMAR" → genera solo la fila CR (con DESCRIPCION "FC.: A INFORMAR"),
                    la fila FC se omite.
                  </span>
                </div>
              </div>
            </div>
          </section>

          {/* ─── Parseo del número de CRT ─── */}
          <section className="space-y-3">
            <h3 className="text-sm font-semibold">Parseo del número de CRT → fila CR</h3>
            <p className="text-xs text-muted-foreground">
              El número de CRT se descompone en <span className="font-medium text-foreground">CEN. EMISOR</span> y{" "}
              <span className="font-medium text-foreground">NUMERO</span> usando el patrón{" "}
              <code className="font-mono">/^([A-Za-z]{"{"}{2}{"}"})(\\d)(\\d+)/</code>.
            </p>
            <div className="rounded border overflow-hidden">
              <table className="w-full text-xs border-collapse">
                <thead>
                  <tr className="bg-muted/50 border-b">
                    <th className="text-left px-3 py-2 font-medium">Número CRT</th>
                    <th className="text-left px-3 py-2 font-medium">CEN. EMISOR</th>
                    <th className="text-left px-3 py-2 font-medium">NUMERO</th>
                    <th className="text-left px-3 py-2 font-medium">Regla</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  <tr>
                    <td className="px-3 py-2 font-mono">BR572600080</td>
                    <td className="px-3 py-2 font-mono">BR 5</td>
                    <td className="px-3 py-2 font-mono">72600080</td>
                    <td className="px-3 py-2 text-muted-foreground">2 letras + espacio + 1er dígito · resto</td>
                  </tr>
                  <tr className="bg-muted/10">
                    <td className="px-3 py-2 font-mono">AR180917213</td>
                    <td className="px-3 py-2 font-mono">AR 1</td>
                    <td className="px-3 py-2 font-mono">80917213</td>
                    <td className="px-3 py-2 text-muted-foreground">2 letras + espacio + 1er dígito · resto</td>
                  </tr>
                  <tr>
                    <td className="px-3 py-2 font-mono">PY611000123</td>
                    <td className="px-3 py-2 font-mono">PY 6</td>
                    <td className="px-3 py-2 font-mono">11000123</td>
                    <td className="px-3 py-2 text-muted-foreground">2 letras + espacio + 1er dígito · resto</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>

          {/* ─── Parseo de factura AR ─── */}
          <section className="space-y-3">
            <h3 className="text-sm font-semibold">Parseo de factura Argentina (AR) → fila FC</h3>
            <p className="text-xs text-muted-foreground">
              Solo aplica cuando el CRT empieza con <code className="font-mono">AR</code>.
              Se distinguen dos formatos según si el invoice contiene guión o no.
            </p>

            {/* Con guión */}
            <div className="space-y-1.5">
              <p className="text-xs font-medium">Con guión: <code className="font-mono">"CCCC-EXXXXXXX"</code></p>
              <div className="rounded border overflow-hidden">
                <table className="w-full text-xs border-collapse">
                  <thead>
                    <tr className="bg-muted/50 border-b">
                      <th className="text-left px-3 py-2 font-medium">Invoice</th>
                      <th className="text-left px-3 py-2 font-medium">CEN. EMISOR</th>
                      <th className="text-left px-3 py-2 font-medium">NUMERO</th>
                      <th className="text-left px-3 py-2 font-medium">Transformación</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    <tr>
                      <td className="px-3 py-2 font-mono">5507-E00013127</td>
                      <td className="px-3 py-2 font-mono">5507</td>
                      <td className="px-3 py-2 font-mono">13127</td>
                      <td className="px-3 py-2 text-muted-foreground">Sin ceros líderes en parte izquierda · dígitos sin prefijo letra y sin ceros líderes</td>
                    </tr>
                    <tr className="bg-muted/10">
                      <td className="px-3 py-2 font-mono">0527-E00015901</td>
                      <td className="px-3 py-2 font-mono">527</td>
                      <td className="px-3 py-2 font-mono">15901</td>
                      <td className="px-3 py-2 text-muted-foreground">Ceros líderes eliminados de ambos lados</td>
                    </tr>
                    <tr>
                      <td className="px-3 py-2 font-mono">0001-E00001234</td>
                      <td className="px-3 py-2 font-mono">1</td>
                      <td className="px-3 py-2 font-mono">1234</td>
                      <td className="px-3 py-2 text-muted-foreground">parseInt elimina ceros líderes</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            {/* Sin guión */}
            <div className="space-y-1.5">
              <p className="text-xs font-medium">Sin guión (tipo E sin separador): <code className="font-mono">"XXXXYYYYYYY"</code></p>
              <div className="rounded border overflow-hidden">
                <table className="w-full text-xs border-collapse">
                  <thead>
                    <tr className="bg-muted/50 border-b">
                      <th className="text-left px-3 py-2 font-medium">Invoice</th>
                      <th className="text-left px-3 py-2 font-medium">CEN. EMISOR</th>
                      <th className="text-left px-3 py-2 font-medium">NUMERO</th>
                      <th className="text-left px-3 py-2 font-medium">Transformación</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y">
                    <tr>
                      <td className="px-3 py-2 font-mono">0006E00015898</td>
                      <td className="px-3 py-2 font-mono">0006</td>
                      <td className="px-3 py-2 font-mono">E00015898</td>
                      <td className="px-3 py-2 text-muted-foreground">Primeros 4 chars · resto (se conservan ceros líderes)</td>
                    </tr>
                    <tr className="bg-muted/10">
                      <td className="px-3 py-2 font-mono">0527E00015901</td>
                      <td className="px-3 py-2 font-mono">0527</td>
                      <td className="px-3 py-2 font-mono">E00015901</td>
                      <td className="px-3 py-2 text-muted-foreground">Primeros 4 chars · resto (se conservan ceros líderes)</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="text-xs text-muted-foreground">
                A diferencia del formato con guión, los ceros a la izquierda en CEN. EMISOR{" "}
                <span className="font-medium text-foreground">se conservan</span> (ej. "0006" permanece "0006").
              </p>
            </div>

            {/* BR/otros */}
            <div className="space-y-1.5">
              <p className="text-xs font-medium">CRTs BR y otros países</p>
              <p className="text-xs text-muted-foreground">
                LETRA = vacío, CEN. EMISOR = vacío, NUMERO = invoice completo tal cual sin transformación.
              </p>
              <div className="rounded border overflow-hidden">
                <table className="w-full text-xs border-collapse">
                  <thead>
                    <tr className="bg-muted/50 border-b">
                      <th className="text-left px-3 py-2 font-medium">Invoice</th>
                      <th className="text-left px-3 py-2 font-medium">LETRA</th>
                      <th className="text-left px-3 py-2 font-medium">CEN. EMISOR</th>
                      <th className="text-left px-3 py-2 font-medium">NUMERO</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="px-3 py-2 font-mono">NES119532/2026</td>
                      <td className="px-3 py-2 text-muted-foreground">(vacío)</td>
                      <td className="px-3 py-2 text-muted-foreground">(vacío)</td>
                      <td className="px-3 py-2 font-mono">NES119532/2026</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>

          {/* ─── Resumen de reglas ─── */}
          <section className="space-y-3">
            <h3 className="text-sm font-semibold">Resumen — qué genera cada combinación</h3>
            <div className="rounded border overflow-hidden">
              <table className="w-full text-xs border-collapse">
                <thead>
                  <tr className="bg-muted/50 border-b">
                    <th className="text-left px-3 py-2 font-medium">Condición</th>
                    <th className="text-left px-3 py-2 font-medium">Fila CR</th>
                    <th className="text-left px-3 py-2 font-medium">Fila FC</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  <tr>
                    <td className="px-3 py-2 text-muted-foreground">CRT normal, invoice con valor real</td>
                    <td className="px-3 py-2 text-green-700 dark:text-green-400">✓ genera</td>
                    <td className="px-3 py-2 text-green-700 dark:text-green-400">✓ genera</td>
                  </tr>
                  <tr className="bg-muted/10">
                    <td className="px-3 py-2 text-muted-foreground">Invoice = "A INFORMAR" (cualquier variante)</td>
                    <td className="px-3 py-2 text-green-700 dark:text-green-400">✓ genera</td>
                    <td className="px-3 py-2 text-red-600 dark:text-red-400">✗ omitida</td>
                  </tr>
                  <tr>
                    <td className="px-3 py-2 text-muted-foreground">CRT con estado Confirmado</td>
                    <td className="px-3 py-2 text-red-600 dark:text-red-400">✗ excluido</td>
                    <td className="px-3 py-2 text-red-600 dark:text-red-400">✗ excluido</td>
                  </tr>
                  <tr className="bg-muted/10">
                    <td className="px-3 py-2 text-muted-foreground">CRT manual (is_manual = true)</td>
                    <td className="px-3 py-2 text-red-600 dark:text-red-400">✗ excluido</td>
                    <td className="px-3 py-2 text-red-600 dark:text-red-400">✗ excluido</td>
                  </tr>
                  <tr>
                    <td className="px-3 py-2 text-muted-foreground">Regla 3a(bis): carrier TJ + propietario TJ</td>
                    <td className="px-3 py-2 text-red-600 dark:text-red-400">✗ excluido</td>
                    <td className="px-3 py-2 text-red-600 dark:text-red-400">✗ excluido</td>
                  </tr>
                  <tr className="bg-muted/10">
                    <td className="px-3 py-2 text-muted-foreground">Regla 3b TJ: carrier TJ + propietario fletero</td>
                    <td className="px-3 py-2 text-red-600 dark:text-red-400">✗ excluido</td>
                    <td className="px-3 py-2 text-red-600 dark:text-red-400">✗ excluido</td>
                  </tr>
                  <tr>
                    <td className="px-3 py-2 text-muted-foreground">Carrier distinto de CDC y TJ</td>
                    <td className="px-3 py-2 text-red-600 dark:text-red-400">✗ excluido</td>
                    <td className="px-3 py-2 text-red-600 dark:text-red-400">✗ excluido</td>
                  </tr>
                  <tr className="bg-muted/10">
                    <td className="px-3 py-2 text-muted-foreground">Regla 3a: carrier TJ + propietario CDC/Kaizen</td>
                    <td className="px-3 py-2 text-green-700 dark:text-green-400">✓ genera</td>
                    <td className="px-3 py-2 text-green-700 dark:text-green-400">✓ genera</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-xs text-muted-foreground">
              La Regla 3a (carrier TJ + propietario CDC/Kaizen) genera documentos normalmente — no hay
              columna CLIENTE NRO en este export, por lo que el reemplazo del legajo por TransJoven
              no aplica aquí (sí aplica en datos de carga).
            </p>
          </section>

          {/* ─── Nota implementación ─── */}
          <section className="rounded border bg-muted/10 px-4 py-3 space-y-1">
            <p className="text-xs font-medium">Nota de implementación</p>
            <p className="text-xs text-muted-foreground">
              El chequeo de "A INFORMAR" se realiza sobre el <span className="font-medium text-foreground">string crudo</span>{" "}
              del invoice, <span className="font-medium text-foreground">antes</span> de pasarlo a la función de parseo.
              Esto es intencional: si se chequeara después del parseo, <code className="font-mono">"A INFORMAR"</code> quedaría
              dividido en <code className="font-mono">CEN. EMISOR="A IN"</code> y{" "}
              <code className="font-mono">NUMERO="FORMAR"</code> por el <code className="font-mono">slice(0,4)</code>,
              y el check nunca matchearía.
              Archivo: <code className="font-mono text-[11px]">apps/api/src/exports/cargo-documents.ts</code>.
            </p>
          </section>

        </div>
      </div>
    </>
  )
}
